export default "/img/SK.204468db98129bea8fc83fca6a37bd35.png";